import { StackProps, SxProps } from '@mui/material';

import { AppTypography } from './app-typography';
import { StackColumn, StackRow } from './stack-column';
import { FeatureBadge } from './subscription/AccountBadge';

//
//

type AppSectionProps = {
  children: React.ReactNode;
  sx?: SxProps;
  border?: boolean;
  title?: string;
  subtitle?: string;
  displayFeatureBadge?: boolean;
  variants?: any;
  background?: string;

  direction?: StackProps['direction'];
  gap?: StackProps['gap'];
  component?: StackProps['component'];
  justifyContent?: StackProps['justifyContent'];
  alignItems?: StackProps['alignItems'];
  flex?: StackProps['flex'];
  className?: string;
};

export const AppSection: React.FC<AppSectionProps> = ({
  children,
  border,
  sx,
  title,
  subtitle,
  displayFeatureBadge,
  background,
  ...props
}) => {
  return (
    <StackColumn
      sx={{
        background: (theme) => background || theme.palette.background.paper,
        border: (theme) => (border ? `1px solid ${theme.palette.divider}` : 'none'),
        p: 2,
        ...sx,
      }}
      {...props}
    >
      {(title || subtitle) && (
        <StackColumn gap={0}>
          {title && (
            <StackRow gap={1} sx={{ mb: subtitle ? 1 : 0, flexWrap: 'wrap' }}>
              <AppTypography variant="title2">{title}</AppTypography>
              {displayFeatureBadge && <FeatureBadge />}
            </StackRow>
          )}

          {subtitle && (
            <AppTypography
              variant="body2"
              className={displayFeatureBadge ? 'disabled-feature' : ''}
            >
              {subtitle}
            </AppTypography>
          )}
        </StackColumn>
      )}

      {children}
    </StackColumn>
  );
};

//

type AppSectionTitleProps = {
  title?: string;
};

export const AppSectionTitle: React.FC<AppSectionTitleProps> = ({ title }) => {
  if (!title) return null;

  return <AppTypography variant="h4">{title}</AppTypography>;
};
